import { RouteEnum } from 'pro/config/routers';
import siteConf from 'pro/config/site';
import Image from '@base/lib/ThemeImage';
import React from 'react';
import styles from '@pro/help/default.module.less';

const VivoSunImg: React.FC = () => {
    return (
        <Image
            src="asset/width-9480/picture/891608928fe96104989a9dc09c7ea82e.png"
            alt={siteConf.brand}
            width={109}
            height={20}
            background={false}
            fixed
        />
    )
}


export default function TermsOfService() {
    return (
        <div className={styles.help}>
            <h1>Intellectual Property</h1>

            <p>The following <VivoSunImg /> products are covered by patents in the US and elsewhere.</p>
            <p>This site is designed to satisfy the virtual patent marking provisions of various jurisdictions, including the virtual patent marking provisions of the America Invents Act, and to provide notices pursuant to 35 USC §287(a) of the United States Patent Act. </p>
            <p>The <VivoSunImg /> products and related US patents listed below may not be exhaustive. For example, some products listed here may be covered by patents in the United States and elsewhere, and other products not listed here may be covered by one or more patents in the United States and elsewhere. </p>
            <p>The products listed below are covered by one or more US patents. Additional patents may be pending in the United States or elsewhere.</p>

            <h2>Product</h2>

            <p><VivoSunImg /> AeroWave A6 Clip-on Fan</p>
            <p>
                Protected by U.S. Patent No.: <br/>
                US29,777,109<br/>
                US17,815,577<br/>
                US16,896,274<br/>
            </p>

            <p> <VivoSunImg /> AeroWave E6 Cilp on Fan</p>
            <p>
                Protected by U.S. Patent No.:<br/>
                US17,815,577<br/>
                US16,896,274<br/>
            </p>
        </div>
    )
};